import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})

export class QuestionnarieDataService {
    constructor(private router: Router, private httpClient: HttpClient) { }

    // Add Questionnarie form
    public addQuestionnarie(data): Observable<any> {
        return this.httpClient.post('questionarie/saveQuestionarie', data).pipe(tap(res => {
            return res;
        }), catchError(error => throwError(() => error)));
    }

    // Get All Questionnarie Form Data
    public getAllQuestionnarie(): Observable<any> {
        return this.httpClient.post('questionarie/getAll', '').pipe(tap(res => {
            return res;
        }), catchError(error => throwError(() => error)));
    }

    // Get Qustionnarie  based on student id 
    public getQuestionnarieByStudentById(data: any): Observable<any> {
        return this.httpClient.post('questionarie/getQuestionarieByStudentId', data).pipe(tap(res => {
            return res;
        }), catchError(error => throwError(() => error)));
    }

    // get all questionnarie form data
    public getAllQuestionnarieList(data: any): Observable<any> {
        return this.httpClient.post('questionarieQus/getAllQuestionarieQusPagination', data).pipe(tap(res => {
            return res;
        }), catchError(error => throwError(() => error)));
    }

    // save dynaqmic questionnarie form
    public saveDynamicQuestionnarie(data: any): Observable<any> {
        return this.httpClient.post('questionarieQus/saveQuestionarieQus', data).pipe(tap(res => {
            return res;
        }), catchError(error => throwError(() => error)));
    }

    // assign questionnarie to institution
    public assignQuestionnaireFormToInstitution(data: any): Observable<any> {
        return this.httpClient.post('questionarieQus/assignQuestionarieByInstitution', data).pipe(tap(res => {
            return res;
        }), catchError(error => throwError(() => error)));
    }

    // view questionnarie form details by id
    public viewQuestionnarieFormDetailsById(questionnarieId: any): Observable<any> {
        return this.httpClient.get('questionarieQus/get/' + questionnarieId).pipe(tap(res => {
            return res;
        }), catchError(error => throwError(() => error)));
    }

    // edit questionnarie form
    public editDynamicQuestionnarie(data: any, id: any): Observable<any> {
        return this.httpClient.put('questionarieQus/update/' + id, data).pipe(tap(res => {
            return res;
        }), catchError(error => throwError(() => error)));
    }

    // Check PDF Conversion
    public checkPdf(data: any): Observable<any> {
        return this.httpClient.post('questionarie/EmailSendInstitution', { data }, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }).pipe(tap(res => {
            return res;
        }), catchError(error => throwError(() => error)));
    }

}